










































































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { AtmReward } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';
import { ATM, ATMTerminalFeeCalculationMethods, ATMTerminalFeeModulus } from '@/api/atmsettings';

@Component
export default class AtmRewardEditor extends Vue {
  @Prop()
  value!:AtmReward;

  @Prop()
  atmSetting!: ATM | null;

  workingReward:AtmReward | null = null;

  // "False" puts the checkboxes in an "invalid" state, since we need at least one to be selected, but doesn't show the error yet.
  // "True" tells them that they are valid.  Any string indicates invalid but show the message.
  checkBoxValidation:boolean|string = false;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  optionalAndPositiveRule:Array<any> = [(value: number) => {
    if (value < 0) {
      return 'Must be positive';
    }
    return true;
  }];

  transactionAmountCalculationMessage(): string {
    if (!this.isCalcFromTransactionAmount()) {
      return '';
    }

    let modulus: number;
    if (this.atmSetting!.terminalFeeModulus === ATMTerminalFeeModulus.TEN_DOLLARS) {
      modulus = 10;
    } else {
      modulus = 5;
    }

    return `FI is currently configured to use MOD ${modulus}, therefore the current system effective cap is ${modulus - 0.01}`;
  }

  isCalcFromTransactionAmount(): boolean {
    if (!this.atmSetting) {
      return false;
    }

    return this.atmSetting.terminalFeeCalculationMethod === ATMTerminalFeeCalculationMethods.CALCULATE_FROM_TRANSACTION_AMOUNT;
  }

  onFeeRuleChange() {
    if (!this.isAtLeastOneFeeRuleSelected()) {
      this.checkBoxValidation = 'Must select at least one atm fee type to refund.';
    } else {
      this.checkBoxValidation = true;
    }
  }

  mounted() {
    this.onExternalRewardValueChanges();
    this.initializeValidation();
  }

  @Watch('value')
  onExternalRewardValueChanges() {
    this.workingReward = this.value.clone() as AtmReward;
  }

  onChange() {
    if ((this.workingReward as any)?.maxRefundAmountPerTransaction === '') {
      // STELLA-2357 - This field should be submitted as null not empty string
      this.workingReward!.maxRefundAmountPerTransaction = null;
    }
    this.$emit('input', this.workingReward);
  }

  initializeValidation() {
    this.checkBoxValidation = this.isAtLeastOneFeeRuleSelected();
  }

  isAtLeastOneFeeRuleSelected(): boolean {
    return this.workingReward !== null && (this.workingReward.refundTerminalFee || this.workingReward.refundForeignAtmUsageFee);
  }
}
